export default __webpack_public_path__ + "static/media/PP1.a4c67dfc.png";